import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const getLeaveReasonMasterData = (data: string) => {
	const URL = `${API_URL}GetAllLeaveReasonDetails`;
	const requestData = {
		GetAllLeaveReasonDetailsToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const updateLeaveReasonMasterData = (data: string) => {
	const URL = `${API_URL}UpdateLeaveReasonDetailsBasedonReasonID`;
	const requestData = {
		UpdateLeaveReasonDetailsToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const addLeaveReasonMasterData = (data: string) => {
	const URL = `${API_URL}AddLeaveReasonDetails`;
	const requestData = {
		AddLeaveReasonDetailsToken: data,
	};
	return makeApiCall(URL, requestData);
};
